export default __webpack_public_path__ + "static/media/blog-img-1.e9bb0543.png";